import React from 'react';
import getCountryName from 'getCountryName';
import { injectIntl } from 'react-intl';

function NoResults({ searchParams, intl }) {
  return (
    <section className="block__no_results" data-testid="no-results">
      <div className="block__no_results_text">
        <div className="body-copy">
          <h3 className="title--s">{intl.formatMessage({ id: 'NoResults.Title' })}</h3>
          <p>
            {intl.formatMessage(
              { id: 'NoResults.Text' },
              {
                occupation: searchParams.occupation,
                location: searchParams.city && searchParams.region ? `${searchParams.city}, ${searchParams.region}` : getCountryName(intl.locale),
              },
            )}
          </p>
          <ul className="list--checks">
            <li>{intl.formatMessage({ id: 'NoResults.ListItem.First' })}</li>
            <li>{intl.formatMessage({ id: 'NoResults.ListItem.Second' })}</li>
          </ul>
        </div>
      </div>
      <div className="block__no_results_image hidden--until-l">
        <img src={`${process.env.REACT_APP_ASSETS_BASE_PATH}/image/${process.env.REACT_APP_COUNTRY === 'sph' ? 'no-results-sph' : 'no-results'}.svg`} alt={intl.formatMessage({ id: 'NoResults.Image.Alt' })} />
      </div>
    </section>
  );
}

export default injectIntl(NoResults);
